var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlackLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 173,
    height: 90,
    viewBox: "0 0 173 90",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355,
    stopColor: "#fff",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 1,
    y1: 0.5,
    x2: 0,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff8400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#ff8400",
    stopOpacity: 0.18
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff8400",
    stopOpacity: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3021",
    "data-name": "Group 3021",
    transform: "translate(-75 -64)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1814",
    "data-name": "Rectangle 1814",
    width: 6,
    height: 1.6,
    transform: "translate(82.9 97.5)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1817",
    "data-name": "Rectangle 1817",
    width: 11,
    height: 1.6,
    transform: "translate(77.9 107.5)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1815",
    "data-name": "Rectangle 1815",
    width: 8,
    height: 1.6,
    transform: "translate(80.9 102.5)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1816",
    "data-name": "Rectangle 1816",
    width: 13.799,
    height: 1.6,
    transform: "translate(75.101 112.4)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3020",
    "data-name": "Group 3020"
  }, /*#__PURE__*/React.createElement("text", {
    id: "RASPER",
    transform: "translate(166 114)",
    fill: "#0d0d0d",
    fontSize: 46,
    fontFamily: "SegoeUI-Light, Segoe UI",
    fontWeight: 300
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -75.446,
    y: 0
  }, "RASPER")), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1818",
    "data-name": "Rectangle 1818",
    width: 173,
    height: 34,
    transform: "translate(75 120)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("text", {
    id: "Powered_by_RapidPricer",
    "data-name": "Powered by RapidPricer",
    transform: "translate(166 141)",
    fontSize: 12,
    fontFamily: "SegoeUI, Segoe UI",
    letterSpacing: "0.032em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -66.683,
    y: 0
  }, "Powered by RapidPricer"))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackLogo);
export default __webpack_public_path__ + "static/media/black_logo.08ef0550f5bf5bbba07035e98f8356f6.svg";
export { ForwardRef as ReactComponent };